export default "Éclairage industriel LED — Fiche CEE BAT-EQ-127 | Solution Éco France";
